import { NgComponentOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Avatar } from '../../../shared/components/avatar/avatar';

import { NavItem } from '../nav-item/nav-item';
import { BookOutline } from '../../../shared/components/icons/book-outline';
import { CalendarOutline } from '../../../shared/components/icons/calendar-outline';
import { DollarCircleBold } from '../../../shared/components/icons/dollar-circle-bold';
import { LogoutOutline } from '../../../shared/components/icons/logout-outline';
import { MedalStarOutline } from '../../../shared/components/icons/medal-star-outline';
import { MoonOutline } from '../../../shared/components/icons/moon-outline';
import { SettingTwoOutline } from '../../../shared/components/icons/setting-two-outline';
import { ShoppingBagOutline } from '../../../shared/components/icons/shopping-bag-outline';
import { ShoppingCartOutline } from '../../../shared/components/icons/shopping-cart-outline';
import { SunOutline } from '../../../shared/components/icons/sun-outline';
import { PrimaryButton } from '../../../shared/components/buttons/primary-button/primary-button';
import { DropdownFormControl } from '../../../shared/components/form-controls/dropdown-form-control/dropdown-form-control';
import { LOCAL_ROUTES } from '../../../core/constants/local-routes.constants';
import { CurrencyCode } from '../../../core/data/currencies';
import { Currency } from '../../../core/services/currency';
import { Theme } from '../../../core/services/theme';
import { CURRENCY_OPTIONS } from '../../../shared/helpers/currency-options';
import { AuthState } from '../../../features/auth/services/auth.state';

@Component({
  selector: 'sidebar-mobile',
  imports: [
    NavItem,
    PrimaryButton,
    Avatar,
    DropdownFormControl,
    NgComponentOutlet,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './sidebar-mobile.html',
  styleUrl: './sidebar-mobile.scss',
  host: {
    '[class.sidebar-mobile-host--left]': "side() === 'left'",
  },
})
export class SidebarMobile {
  private authState = inject(AuthState);
  private theme = inject(Theme);
  private currency = inject(Currency);

  userName = input<string | null>(null);
  userImage = input<string | null>(null);
  userEmail = input<string | null>(null);
  side = input<'left' | 'right'>('right');

  isLoggedIn = computed(() => !!this.userName());

  routes = LOCAL_ROUTES;
  currencyOptions = CURRENCY_OPTIONS;
  currentCode = this.currency.currentCode;
  darkMode = this.theme.darkMode;

  themeLabel = computed(() => (this.darkMode() ? 'Modo claro' : 'Modo oscuro'));
  themeIcon = computed(() => (this.darkMode() ? SunOutline : MoonOutline));

  BookOutline = BookOutline;
  CalendarOutline = CalendarOutline;
  DollarCircleBold = DollarCircleBold;
  LogoutOutline = LogoutOutline;
  MedalStarOutline = MedalStarOutline;
  SettingTwoOutline = SettingTwoOutline;
  ShoppingBagOutline = ShoppingBagOutline;
  ShoppingCartOutline = ShoppingCartOutline;

  setCurrency(value: CurrencyCode | null): void {
    if (!value) return;
    this.currency.setCurrency(value);
  }

  toggleDarkMode(): void {
    this.theme.setDarkMode(!this.darkMode());
  }

  logout() {
    this.authState.logout();
  }
}
